/**
 * Remembers each person's assistant settings in this browser (theme, text size, send key, steps,
 * tool groups). Per-viewer convenience only: storage can be missing or throw, and that must never
 * stop the assistant; it just starts from the defaults.
 */
import { ASSISTANT_PREFS_STORAGE_KEY } from '@Assistant/constants/assistant.constants';
import { normalizePreferences, DEFAULT_PREFERENCES } from '@Assistant/domain/preferences';

const keyFor = (userId) => `${ASSISTANT_PREFS_STORAGE_KEY}:${userId}`;

export function readPreferences(userId) {
  if (!userId) return DEFAULT_PREFERENCES;
  try {
    const raw = window.localStorage.getItem(keyFor(userId));
    return normalizePreferences(raw ? JSON.parse(raw) : null);
  } catch (err) {
    return DEFAULT_PREFERENCES;
  }
}

export function writePreferences(userId, prefs) {
  if (!userId) return;
  try {
    window.localStorage.setItem(keyFor(userId), JSON.stringify(prefs));
  } catch (err) {
    // Storage unavailable: the settings apply now but won't be remembered next time.
  }
}
